import { Select } from '@iqueue/ui-kit'
import HelpersPresenter from '../../api/helpersPresenter'
import { useCallback } from 'react'
import { t } from '../../hooks/useTranslate'

export default function PickSensorType({
  name = 'type',
  value,
  ...props
}) {

  const render = useCallback((key) => {
    return {
      key,
      title: t(`type.sensor.${ key }`),
    }
  }, [t])

  return <Select
    name={ name }
    entries={ HelpersPresenter.sensorTypes }
    render={ render }
    value={ value }
    { ...props }
  />
}
